export default __webpack_public_path__ + "static/media/tiivii-guia-mobile-2.c85159c4.png";